import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { List } from './MenuStyle';
import MenuItem from './MenuItem';
import { USER_MENUS_QUERY } from '../queries';
import { useQueryWithErrorHandling } from '@ts-private/apollo-tools';
import { useOidcUser } from '@axa-fr/react-oidc';
import { getOidcConfigName } from 'utils/functions';

const Menu = ({ drawerOpen }) => {
  const location = useLocation();
  const { oidcUser } = useOidcUser(getOidcConfigName());

  const activeRoute = routeName => {
    return location.pathname.indexOf(routeName) > -1 ? true : false;
  };

  const { data, loading: loadingUserMenus } = useQueryWithErrorHandling(USER_MENUS_QUERY, {
    skip: !oidcUser
  });

  return (
    <>
      {data?.userMenus?.menuItems && !loadingUserMenus && (
        <nav>
          <List>
            {data.userMenus.menuItems.map((menu, key) => {
              const newMenu = { text: menu.caption, name: menu.description, icon: menu.menuIcon, path: menu.menuRoute };
              return <MenuItem key={key} menu={newMenu} drawerOpen={drawerOpen} activeRoute={activeRoute} />;
            })}
          </List>
        </nav>
      )}
    </>
  );
};

Menu.propTypes = {
  drawerOpen: PropTypes.bool.isRequired
};

export default Menu;
